import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/standardTrialLimitBreakersModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	jiraApplicationKey: JiraApplicationKey;
	projectType: JiraProjectType;
	shouldIncludeIfProductIsConfluence: boolean;
	shouldIncludeIfProductIsJiraSoftware: boolean;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-trial-limit-breakers-modal" */ './standard-trial-limit-breakers-modal'
			),
		{
			moduleId: 'edition-awareness-standard-trial-limit-breakers-modal',
		},
	),
	getPreloadProps: ({
		cloudId,
		jiraApplicationKey,
		projectType,
		shouldIncludeIfProductIsConfluence,
		shouldIncludeIfProductIsJiraSoftware,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			standardTrialLimitBreakersModalQuery: {
				parameters,
				variables: {
					cloudId,
					jiraApplicationKey,
					projectType,
					shouldIncludeIfProductIsConfluence,
					shouldIncludeIfProductIsJiraSoftware,
				},
			},
		},
	}),
});
